export default __webpack_public_path__ + "static/media/link.f4fc3e0f.svg";